import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './QuestionAnswerItem.module.scss';
const QuestionAnswerItem = ({ question, answer }) => {
    return (_jsxs("div", Object.assign({ className: styles.item }, { children: [_jsx("h5", Object.assign({ className: styles.question }, { children: question })), _jsx("p", Object.assign({ className: styles.answer }, { children: answer }))] })));
};
export default React.memo(QuestionAnswerItem);
